module.exports = __webpack_public_path__ + "static/media/home.ef8314de.svg";